import { useEffect, useRef, useState } from 'react';
import { catalogueQuery, listingFacets } from '../lib/catalogue-query';
import { catalogueListingRequest, peekCatalogueListing } from '../lib/catalogue-listing-cache';

const resultState = data => ({ products: data.results, total: data.total, loading: false, error: null,
  facetOptions: listingFacets(data.facets), grouped: data.grouped, countUnit: data.count_unit });

export const useCatalogueResults = filters => {
  const query = catalogueQuery(filters);
  const [retry, setRetry] = useState(0);
  const previousRetry = useRef(0);
  const path = `/search/products?${query}`;
  const [state, setState] = useState(() => {
    const cached = peekCatalogueListing(path);
    return cached ? resultState(cached) : { products: [], total: 0, loading: true, error: null, facetOptions: listingFacets(), grouped: true, countUnit: 'families' };
  });
  useEffect(() => {
    const controller = new AbortController();
    const force = retry !== previousRetry.current;
    previousRetry.current = retry;
    const cached = force ? null : peekCatalogueListing(path);
    setState(previous => cached ? resultState(cached) : ({ ...previous, loading: true, error: null }));
    catalogueListingRequest(path, { signal: controller.signal, force })
      .then(data => {
        if (controller.signal.aborted) return;
        setState(resultState(data));
        if (data.page !== filters.page) filters.setPage(data.page);
      })
      .catch(error => { if (!controller.signal.aborted) setState(previous => ({ ...previous, loading: false, error: error.message })); });
    return () => controller.abort();
    // query includes all effective selections; callbacks must not retrigger a request.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, retry]);
  return { ...state, retry: () => setRetry(value => value + 1) };
};